import { isLocalhost, isProduction, ObFlowService, SentryService } from '@web_opxp/features';
import { LanguageService } from '@web_opxp/language';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { HistoryService } from 'web_core_library';
import Root from './Root';
import * as ENV from './core/env';
import { BasePath, BlogPath, BuildID, OnboardingAppPath, SubscribeAppPath, TrainingAppPath } from './core/env';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import * as LocalHistoryService from './services/historyService';

if (!isLocalhost) {
  SentryService.initSentry(isProduction(), BuildID);
}
if (!isProduction()) {
  SentryService.enableReplay();
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Incorrect template. Application root not found on the page!');
}
const root = createRoot(container);
export const router = createBrowserRouter(
  [
    {
      path: '/*',
      element: <Root />,
    },
  ],
  { basename: BasePath }
);

HistoryService.initialize(router, {
  loginBaseUrl: '',
  logoutBaseUrl: '',
  BlogBaseUrl: BlogPath,
  getLanguageFunction: () => LanguageService.getLanguage() as string,
  OnboardingAppPath: OnboardingAppPath,
  SocialAppPath: '',
  SubscribeUrl: SubscribeAppPath,
  TrainingBaseUrl: TrainingAppPath,
  signupBaseUrl: '',
});

LocalHistoryService.urlManager.reload();
const currentSearchParams = LocalHistoryService.urlManager.getUrlSearchParams();

ObFlowService.init('sso', currentSearchParams, ENV.AssetsBaseUrl, {
  getExternalUrl: HistoryService.getExternalUrl,
  getInternalUrl: HistoryService.getInternalUrl,
  getRegistrationUrl: (backUrl: string, lang?: string) => LocalHistoryService.getSignupUrl(undefined, backUrl, lang),
  redirectExternal: HistoryService.redirectExternal,
  redirectInternal: HistoryService.redirectWithState,
  redirectRegistration: () => LocalHistoryService.redirectToSignup(),
  urlMap: {
    training: ENV.TrainingAppPath,
    onboarding: ENV.OnboardingAppPath,
    subscribe: ENV.SubscribeAppPath,
  },
});

root.render(<RouterProvider router={router} />);

serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
